@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.auth.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/mobile_wallet.feature.auth.generated.resources/"

internal val Res.string.feature_auth_address_line_1: StringResource by lazy {
      StringResource("string:feature_auth_address_line_1", "feature_auth_address_line_1", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 55),
      ))
    }

internal val Res.string.feature_auth_address_line_2: StringResource by lazy {
      StringResource("string:feature_auth_address_line_2", "feature_auth_address_line_2", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66, 71),
      ))
    }

internal val Res.string.feature_auth_all_fields_are_mandatory: StringResource by lazy {
      StringResource("string:feature_auth_all_fields_are_mandatory", "feature_auth_all_fields_are_mandatory", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138, 109),
      ))
    }

internal val Res.string.feature_auth_complete: StringResource by lazy {
      StringResource("string:feature_auth_complete", "feature_auth_complete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 332, 41),
      ))
    }

internal val Res.string.feature_auth_complete_your_registration: StringResource by lazy {
      StringResource("string:feature_auth_complete_your_registration", "feature_auth_complete_your_registration", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248, 83),
      ))
    }

internal val Res.string.feature_auth_confirm_password: StringResource by lazy {
      StringResource("string:feature_auth_confirm_password", "feature_auth_confirm_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 374, 61),
      ))
    }

internal val Res.string.feature_auth_connected_to: StringResource by lazy {
      StringResource("string:feature_auth_connected_to", "feature_auth_connected_to", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 436, 57),
      ))
    }

internal val Res.string.feature_auth_country: StringResource by lazy {
      StringResource("string:feature_auth_country", "feature_auth_country", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 494, 40),
      ))
    }

internal val Res.string.feature_auth_create_an_account: StringResource by lazy {
      StringResource("string:feature_auth_create_an_account", "feature_auth_create_an_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 535, 62),
      ))
    }

internal val Res.string.feature_auth_default_web_client_id: StringResource by lazy {
      StringResource("string:feature_auth_default_web_client_id", "feature_auth_default_web_client_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 598, 138),
      ))
    }

internal val Res.string.feature_auth_email: StringResource by lazy {
      StringResource("string:feature_auth_email", "feature_auth_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 737, 34),
      ))
    }

internal val Res.string.feature_auth_enter_mobile_number: StringResource by lazy {
      StringResource("string:feature_auth_enter_mobile_number", "feature_auth_enter_mobile_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 965, 68),
      ))
    }

internal val Res.string.feature_auth_enter_mobile_number_description: StringResource by lazy {
      StringResource("string:feature_auth_enter_mobile_number_description", "feature_auth_enter_mobile_number_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 772, 192),
      ))
    }

internal val Res.string.feature_auth_enter_otp: StringResource by lazy {
      StringResource("string:feature_auth_enter_otp", "feature_auth_enter_otp", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1134, 42),
      ))
    }

internal val Res.string.feature_auth_enter_otp_received: StringResource by lazy {
      StringResource("string:feature_auth_enter_otp_received", "feature_auth_enter_otp_received", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1034, 99),
      ))
    }

internal val Res.string.feature_auth_error_address_line1_required: StringResource by lazy {
      StringResource("string:feature_auth_error_address_line1_required", "feature_auth_error_address_line1_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1177, 93),
      ))
    }

internal val Res.string.feature_auth_error_check_uniqueness_failed: StringResource by lazy {
      StringResource("string:feature_auth_error_check_uniqueness_failed", "feature_auth_error_check_uniqueness_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1271, 130),
      ))
    }

internal val Res.string.feature_auth_error_confirm_password_required: StringResource by lazy {
      StringResource("string:feature_auth_error_confirm_password_required", "feature_auth_error_confirm_password_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1402, 112),
      ))
    }

internal val Res.string.feature_auth_error_country_required: StringResource by lazy {
      StringResource("string:feature_auth_error_country_required", "feature_auth_error_country_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1515, 79),
      ))
    }

internal val Res.string.feature_auth_error_email_invalid: StringResource by lazy {
      StringResource("string:feature_auth_error_email_invalid", "feature_auth_error_email_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1595, 76),
      ))
    }

internal val Res.string.feature_auth_error_email_required: StringResource by lazy {
      StringResource("string:feature_auth_error_email_required", "feature_auth_error_email_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1672, 73),
      ))
    }

internal val Res.string.feature_auth_error_field_already_exists: StringResource by lazy {
      StringResource("string:feature_auth_error_field_already_exists", "feature_auth_error_field_already_exists", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1746, 75),
      ))
    }

internal val Res.string.feature_auth_error_first_name_required: StringResource by lazy {
      StringResource("string:feature_auth_error_first_name_required", "feature_auth_error_first_name_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1822, 86),
      ))
    }

internal val Res.string.feature_auth_error_last_name_required: StringResource by lazy {
      StringResource("string:feature_auth_error_last_name_required", "feature_auth_error_last_name_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1909, 85),
      ))
    }

internal val Res.string.feature_auth_error_mobile_invalid: StringResource by lazy {
      StringResource("string:feature_auth_error_mobile_invalid", "feature_auth_error_mobile_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1995, 93),
      ))
    }

internal val Res.string.feature_auth_error_mobile_required: StringResource by lazy {
      StringResource("string:feature_auth_error_mobile_required", "feature_auth_error_mobile_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2089, 86),
      ))
    }

internal val Res.string.feature_auth_error_password_invalid: StringResource by lazy {
      StringResource("string:feature_auth_error_password_invalid", "feature_auth_error_password_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2176, 99),
      ))
    }

internal val Res.string.feature_auth_error_password_required: StringResource by lazy {
      StringResource("string:feature_auth_error_password_required", "feature_auth_error_password_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2276, 92),
      ))
    }

internal val Res.string.feature_auth_error_passwords_mismatch: StringResource by lazy {
      StringResource("string:feature_auth_error_passwords_mismatch", "feature_auth_error_passwords_mismatch", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2369, 77),
      ))
    }

internal val Res.string.feature_auth_error_pincode_required: StringResource by lazy {
      StringResource("string:feature_auth_error_pincode_required", "feature_auth_error_pincode_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2447, 79),
      ))
    }

internal val Res.string.feature_auth_error_select_savings_account: StringResource by lazy {
      StringResource("string:feature_auth_error_select_savings_account", "feature_auth_error_select_savings_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2527, 93),
      ))
    }

internal val Res.string.feature_auth_error_state_required: StringResource by lazy {
      StringResource("string:feature_auth_error_state_required", "feature_auth_error_state_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2621, 73),
      ))
    }

internal val Res.string.feature_auth_error_username_required: StringResource by lazy {
      StringResource("string:feature_auth_error_username_required", "feature_auth_error_username_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2695, 80),
      ))
    }

internal val Res.string.feature_auth_first_name: StringResource by lazy {
      StringResource("string:feature_auth_first_name", "feature_auth_first_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2776, 47),
      ))
    }

internal val Res.string.feature_auth_google_account: StringResource by lazy {
      StringResource("string:feature_auth_google_account", "feature_auth_google_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2824, 83),
      ))
    }

internal val Res.string.feature_auth_last_name: StringResource by lazy {
      StringResource("string:feature_auth_last_name", "feature_auth_last_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2908, 42),
      ))
    }

internal val Res.string.feature_auth_logging_in: StringResource by lazy {
      StringResource("string:feature_auth_logging_in", "feature_auth_logging_in", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2951, 51),
      ))
    }

internal val Res.string.feature_auth_login: StringResource by lazy {
      StringResource("string:feature_auth_login", "feature_auth_login", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3003, 34),
      ))
    }

internal val Res.string.feature_auth_mobile_no: StringResource by lazy {
      StringResource("string:feature_auth_mobile_no", "feature_auth_mobile_no", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3038, 42),
      ))
    }

internal val Res.string.feature_auth_name_of_business: StringResource by lazy {
      StringResource("string:feature_auth_name_of_business", "feature_auth_name_of_business", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3081, 61),
      ))
    }

internal val Res.string.feature_auth_or: StringResource by lazy {
      StringResource("string:feature_auth_or", "feature_auth_or", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3143, 27),
      ))
    }

internal val Res.string.feature_auth_password: StringResource by lazy {
      StringResource("string:feature_auth_password", "feature_auth_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3553, 41),
      ))
    }

internal val Res.string.feature_auth_password_requirements: StringResource by lazy {
      StringResource("string:feature_auth_password_requirements", "feature_auth_password_requirements", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3171, 318),
      ))
    }

internal val Res.string.feature_auth_password_strength: StringResource by lazy {
      StringResource("string:feature_auth_password_strength", "feature_auth_password_strength", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3490, 62),
      ))
    }

internal val Res.string.feature_auth_phone_number: StringResource by lazy {
      StringResource("string:feature_auth_phone_number", "feature_auth_phone_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3595, 49),
      ))
    }

internal val Res.string.feature_auth_pin_code: StringResource by lazy {
      StringResource("string:feature_auth_pin_code", "feature_auth_pin_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3645, 41),
      ))
    }

internal val Res.string.feature_auth_registration_successful: StringResource by lazy {
      StringResource("string:feature_auth_registration_successful", "feature_auth_registration_successful", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3687, 76),
      ))
    }

internal val Res.string.feature_auth_sign_up: StringResource by lazy {
      StringResource("string:feature_auth_sign_up", "feature_auth_sign_up", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3902, 40),
      ))
    }

internal val Res.string.feature_auth_sign_up_as_customer: StringResource by lazy {
      StringResource("string:feature_auth_sign_up_as_customer", "feature_auth_sign_up_as_customer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3764, 68),
      ))
    }

internal val Res.string.feature_auth_sign_up_as_merchant: StringResource by lazy {
      StringResource("string:feature_auth_sign_up_as_merchant", "feature_auth_sign_up_as_merchant", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3833, 68),
      ))
    }

internal val Res.string.feature_auth_state: StringResource by lazy {
      StringResource("string:feature_auth_state", "feature_auth_state", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3943, 34),
      ))
    }

internal val Res.string.feature_auth_username: StringResource by lazy {
      StringResource("string:feature_auth_username", "feature_auth_username", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3978, 41),
      ))
    }

internal val Res.string.feature_auth_validate_email: StringResource by lazy {
      StringResource("string:feature_auth_validate_email", "feature_auth_validate_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4020, 83),
      ))
    }

internal val Res.string.feature_auth_verify_otp: StringResource by lazy {
      StringResource("string:feature_auth_verify_otp", "feature_auth_verify_otp", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4104, 47),
      ))
    }

internal val Res.string.feature_auth_verify_phone: StringResource by lazy {
      StringResource("string:feature_auth_verify_phone", "feature_auth_verify_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4152, 49),
      ))
    }

internal val Res.string.feature_auth_welcome_back: StringResource by lazy {
      StringResource("string:feature_auth_welcome_back", "feature_auth_welcome_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4202, 53),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_auth_address_line_1", Res.string.feature_auth_address_line_1)
  map.put("feature_auth_address_line_2", Res.string.feature_auth_address_line_2)
  map.put("feature_auth_all_fields_are_mandatory", Res.string.feature_auth_all_fields_are_mandatory)
  map.put("feature_auth_complete", Res.string.feature_auth_complete)
  map.put("feature_auth_complete_your_registration", Res.string.feature_auth_complete_your_registration)
  map.put("feature_auth_confirm_password", Res.string.feature_auth_confirm_password)
  map.put("feature_auth_connected_to", Res.string.feature_auth_connected_to)
  map.put("feature_auth_country", Res.string.feature_auth_country)
  map.put("feature_auth_create_an_account", Res.string.feature_auth_create_an_account)
  map.put("feature_auth_default_web_client_id", Res.string.feature_auth_default_web_client_id)
  map.put("feature_auth_email", Res.string.feature_auth_email)
  map.put("feature_auth_enter_mobile_number", Res.string.feature_auth_enter_mobile_number)
  map.put("feature_auth_enter_mobile_number_description", Res.string.feature_auth_enter_mobile_number_description)
  map.put("feature_auth_enter_otp", Res.string.feature_auth_enter_otp)
  map.put("feature_auth_enter_otp_received", Res.string.feature_auth_enter_otp_received)
  map.put("feature_auth_error_address_line1_required", Res.string.feature_auth_error_address_line1_required)
  map.put("feature_auth_error_check_uniqueness_failed", Res.string.feature_auth_error_check_uniqueness_failed)
  map.put("feature_auth_error_confirm_password_required", Res.string.feature_auth_error_confirm_password_required)
  map.put("feature_auth_error_country_required", Res.string.feature_auth_error_country_required)
  map.put("feature_auth_error_email_invalid", Res.string.feature_auth_error_email_invalid)
  map.put("feature_auth_error_email_required", Res.string.feature_auth_error_email_required)
  map.put("feature_auth_error_field_already_exists", Res.string.feature_auth_error_field_already_exists)
  map.put("feature_auth_error_first_name_required", Res.string.feature_auth_error_first_name_required)
  map.put("feature_auth_error_last_name_required", Res.string.feature_auth_error_last_name_required)
  map.put("feature_auth_error_mobile_invalid", Res.string.feature_auth_error_mobile_invalid)
  map.put("feature_auth_error_mobile_required", Res.string.feature_auth_error_mobile_required)
  map.put("feature_auth_error_password_invalid", Res.string.feature_auth_error_password_invalid)
  map.put("feature_auth_error_password_required", Res.string.feature_auth_error_password_required)
  map.put("feature_auth_error_passwords_mismatch", Res.string.feature_auth_error_passwords_mismatch)
  map.put("feature_auth_error_pincode_required", Res.string.feature_auth_error_pincode_required)
  map.put("feature_auth_error_select_savings_account", Res.string.feature_auth_error_select_savings_account)
  map.put("feature_auth_error_state_required", Res.string.feature_auth_error_state_required)
  map.put("feature_auth_error_username_required", Res.string.feature_auth_error_username_required)
  map.put("feature_auth_first_name", Res.string.feature_auth_first_name)
  map.put("feature_auth_google_account", Res.string.feature_auth_google_account)
  map.put("feature_auth_last_name", Res.string.feature_auth_last_name)
  map.put("feature_auth_logging_in", Res.string.feature_auth_logging_in)
  map.put("feature_auth_login", Res.string.feature_auth_login)
  map.put("feature_auth_mobile_no", Res.string.feature_auth_mobile_no)
  map.put("feature_auth_name_of_business", Res.string.feature_auth_name_of_business)
  map.put("feature_auth_or", Res.string.feature_auth_or)
  map.put("feature_auth_password", Res.string.feature_auth_password)
  map.put("feature_auth_password_requirements", Res.string.feature_auth_password_requirements)
  map.put("feature_auth_password_strength", Res.string.feature_auth_password_strength)
  map.put("feature_auth_phone_number", Res.string.feature_auth_phone_number)
  map.put("feature_auth_pin_code", Res.string.feature_auth_pin_code)
  map.put("feature_auth_registration_successful", Res.string.feature_auth_registration_successful)
  map.put("feature_auth_sign_up", Res.string.feature_auth_sign_up)
  map.put("feature_auth_sign_up_as_customer", Res.string.feature_auth_sign_up_as_customer)
  map.put("feature_auth_sign_up_as_merchant", Res.string.feature_auth_sign_up_as_merchant)
  map.put("feature_auth_state", Res.string.feature_auth_state)
  map.put("feature_auth_username", Res.string.feature_auth_username)
  map.put("feature_auth_validate_email", Res.string.feature_auth_validate_email)
  map.put("feature_auth_verify_otp", Res.string.feature_auth_verify_otp)
  map.put("feature_auth_verify_phone", Res.string.feature_auth_verify_phone)
  map.put("feature_auth_welcome_back", Res.string.feature_auth_welcome_back)
}
